"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.databaseRules = void 0;
const validateUnique_1 = require("./validateUnique");
const validateResourceSelectValue_1 = require("./validateResourceSelectValue");
// These are the validations that require a database connection.
exports.databaseRules = [
    validateUnique_1.validateUniqueInfo,
    validateResourceSelectValue_1.validateResourceSelectValueInfo,
];
